import { VALIDATION_STATE } from '../constants';
export function getValidationState({ validationState, error }) {
    return error ? VALIDATION_STATE.Error : validationState !== null && validationState !== void 0 ? validationState : VALIDATION_STATE.Default;
}
